import React from "react";
import { PartOfSpeech, Register } from "../types";
import { useLanguage } from "../contexts/LanguageContext";
import { useTranslations } from "../translations";
import "./Filters.css";

interface FiltersProps {
  partOfSpeech: PartOfSpeech | "";
  register: Register | "";
  minFrequency: number;
  onPartOfSpeechChange: (value: PartOfSpeech | "") => void;
  onRegisterChange: (value: Register | "") => void;
  onMinFrequencyChange: (value: number) => void;
  onClearFilters: () => void;
}

const Filters: React.FC<FiltersProps> = ({
  partOfSpeech,
  register,
  minFrequency,
  onPartOfSpeechChange,
  onRegisterChange,
  onMinFrequencyChange,
  onClearFilters,
}) => {
  const { language } = useLanguage();
  const t = useTranslations(language);

  const partsOfSpeech: (PartOfSpeech | "")[] = [
    "",
    "noun",
    "verb",
    "adjective",
    "adverb",
    "preposition",
    "conjunction",
    "interjection",
  ];

  const registers: (Register | "")[] = [
    "",
    "formal",
    "informal",
    "neutral",
    "colloquial",
    "technical",
  ];

  return (
    <div className="filters">
      <h3 className="filters-title">{t.filters}</h3>

      <div className="filter-group">
        <label htmlFor="part-of-speech">{t.partOfSpeech}:</label>
        <select
          id="part-of-speech"
          value={partOfSpeech}
          onChange={(e) => onPartOfSpeechChange(e.target.value as PartOfSpeech | "")}
        >
          <option value="">{t.all}</option>
          {partsOfSpeech.slice(1).map((pos) => (
            <option key={pos} value={pos}>
              {pos}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="register">{t.register}:</label>
        <select
          id="register"
          value={register}
          onChange={(e) => onRegisterChange(e.target.value as Register | "")}
        >
          <option value="">{t.all}</option>
          {registers.slice(1).map((reg) => (
            <option key={reg} value={reg}>
              {reg}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="min-frequency">
          {t.minFrequency}: {minFrequency}/5
        </label>
        <input
          type="range"
          id="min-frequency"
          min="1"
          max="5"
          value={minFrequency}
          onChange={(e) => onMinFrequencyChange(Number(e.target.value))}
        />
      </div>

      <button className="clear-filters-btn" onClick={onClearFilters}>
        {t.clearFilters}
      </button>
    </div>
  );
};

export default Filters;
